import S_scope from '@/service/api/v1/scope';

export default {
  getDrawerItems: () => {
    return [
      {
        id: 'organization-dashboard',
        module: 'organization',
        textLabel: '集團總覽',
        leadingIcon: 'icon-earth-outline',
        activiatedLeadingIcon: 'icon-earth-filled',
        activiated: false,
        disabled: !S_scope.$_isAvailable(['organization-dashboard-read']),
        link: '/organization-dashboard',
      },
      {
        id: 'factory-dashboard',
        module: 'organization',
        textLabel: '各單位總覽',
        leadingIcon: 'icon-nav-pie-outline',
        activiatedLeadingIcon: 'icon-nav-pie-filled',
        activiated: false,
        disabled: !S_scope.$_isAvailable(['factory-dashboard-read']),
        link: '/factory-dashboard',
      },
      {
        id: 'overview',
        module: 'dashboard',
        textLabel: '本單位總覽',
        leadingIcon: 'icon-nav-pie-outline',
        activiatedLeadingIcon: 'icon-nav-pie-filled',
        activiated: false,
        disabled: !S_scope.$_isAvailable(['dashboard-read']),
        link: '/dashboard-main',
      },
      {
        id: 'board',
        module: 'board',
        textLabel: '看板',
        leadingIcon: 'icon-nav-board',
        activiatedLeadingIcon: 'icon-nav-board',
        activiated: false,
        link: '/board-overview',
      },
      {
        id: 'alert',
        module: 'alert',
        textLabel: '警示',
        leadingIcon: 'icon-nav-alert-outline',
        activiatedLeadingIcon: 'icon-nav-alert-filled',
        activiated: false,
        disabled: !S_scope.$_isAvailable(['alert-read']),
        link: '/alerts',
      },
      {
        id: 'management',
        module: 'core',
        textLabel: '管理',
        leadingIcon: 'icon-nav-filemanage',
        activiatedLeadingIcon: 'icon-nav-filemanage-open',
        activiated: false,
        link: '/management',
        hasSubItems: true,
        subList: [
          {
            id: 'tasks',
            module: 'task',
            textLabel: '任務',
            link: '/tasks',
            disabled:
              !S_scope.$_isAvailable(['task-read']) && !S_scope.$_isAvailable(['task-read-all']),
            active: false,
          },
          {
            id: 'checklists',
            module: 'checklist',
            textLabel: '日常自檢',
            link: '/checklists',
            disabled: !S_scope.$_isAvailable(['checklist-read']),
            active: false,
          },
          {
            id: 'changes',
            module: 'change',
            textLabel: '變動管理',
            link: '/changes',
            disabled: !S_scope.$_isAvailable(['change-read']),
            active: false,
          },
          {
            id: 'licenses',
            module: 'license',
            textLabel: '證照管理',
            link: '/licenses',
            disabled: !S_scope.$_isAvailable(['license-read']),
            active: false,
          },
          {
            id: 'trainings',
            module: 'training',
            textLabel: '教育訓練',
            link: '/trainings',
            disabled: !S_scope.$_isAvailable(['internal-training-read']),
            active: false,
          },
          {
            id: 'events',
            module: 'event',
            textLabel: '風險事件',
            link: '/events',
            disabled: !S_scope.$_isAvailable(['event-read']),
            active: false,
          },
          {
            id: 'audits',
            module: 'audit',
            textLabel: '稽核管理',
            link: '/audits',
            disabled: !S_scope.$_isAvailable(['audit-read']),
            active: false,
          },
          {
            id: 'contractors',
            module: 'contractor',
            textLabel: '承攬商管理',
            link: '/contractors',
            disabled: !S_scope.$_isAvailable(['contractor-read']),
            active: false,
          },
          {
            id: 'operations',
            module: 'contractor',
            textLabel: '進場管理',
            link: '/contractor-operations',
            disabled: !S_scope.$_isAvailable(['contractor-enter-record-read']),
            active: false,
          },
          {
            id: 'files',
            module: 'file',
            textLabel: '文件檔案庫',
            link: '/files?tab=thisUnit',
            disabled: false,
            active: false,
          },
          {
            id: 'meeting',
            module: 'meeting',
            textLabel: '議事',
            link: '/meetings',
            disabled: !S_scope.$_isAvailable(['meeting-read']) && !S_scope.$_isAvailable(['meeting-template-read']),
            active: false,
          },
          {
            id: 'guidelineAdmin',
            module: 'guideline',
            textLabel: '內規管理',
            link: '/guideline-admins',
            disabled: false,
            active: false,
          },
          {
            id: 'qrcode',
            module: 'qrcode',
            textLabel: 'QRcode工具',
            link: '/qrcodes',
            disabled: !S_scope.$_isAvailable(['qrcode-read']),
            active: false,
          },
          {
            id: 'logs',
            module: 'log',
            textLabel: '操作記錄',
            link: '/logs',
            disabled: !S_scope.$_isAvailable(['log-manage']),
            active: false,
          },
        ],
      },
      {
        id: 'acts',
        module: 'act',
        textLabel: '法規',
        leadingIcon: 'icon-nav-law-filled',
        activiatedLeadingIcon: 'icon-nav-law-filled',
        disabled: !S_scope.$_isAvailable(['act-read']),
        activiated: false,
        link: '/acts',
      },
      {
        id: 'guideline',
        module: 'guideline',
        textLabel: '內規',
        leadingIcon: 'icon-ll-nav-internalegulations-outline',
        activiatedLeadingIcon: 'icon-ll-nav-internalegulations-filled',
        disabled: !S_scope.$_isAvailable(['guideline-read']),
        activiated: false,
        link: '/guidelines',
      },
      {
        id: 'broadcasts',
        module: 'broadcast',
        textLabel: 'ESGoal快報',
        leadingIcon: 'icon-nav-news-outline',
        activiatedLeadingIcon: 'icon-nav-news-filled',
        disabled: !S_scope.$_isAvailable(['llbroadcast-read']),
        activiated: false,
        link: '/broadcasts',
      },
      {
        id: 'announcement',
        module: 'announcement',
        textLabel: '新訊',
        leadingIcon: 'icon-ll-esh-fairtrade',
        activiatedLeadingIcon: 'icon-ll-esh-fairtrade',
        activiated: false,
        link: '/announcements',
      },
      {
        id: 'setting',
        module: 'setting',
        textLabel: '設定',
        leadingIcon: 'icon-settings-outline',
        activiatedLeadingIcon: 'icon-settings-filled',
        activiated: false,
        link: '/setting-main',
      },
    ];
  },
};
